export default {
  lang: { name: 'Español', code: 'es', flag: '🇪🇸' },
  common: {
    whatsapp: 'WhatsApp',
    email: 'Correo',
    sendEmail: 'Enviar correo',
    sendInquiry: 'Enviar consulta',
    contactSupplier: 'Contactar proveedor',
    viewDetails: 'Ver detalles',
    viewAll: 'Ver todo',
    loading: 'Cargando…',
    backHome: 'Volver al inicio',
    negotiable: 'Precio negociable',
    perPiece: '/ unidad',
    moq: 'Pedido mín: 1 unidad',
    inStock: 'En stock',
    refresh: 'actualizar',
    chatNow: 'Chatear ahora',
    chooseContact: 'Elija un contacto de ventas',
    notFound: 'No se encontraron resultados'
  },
  nav: {
    home: 'Inicio',
    products: 'Productos',
    examples: 'Proyectos',
    about: 'Nosotros',
    contact: 'Contacto'
  },
  header: {
    callUs: 'Llámenos',
    quickNav: 'Navegación rápida',
    tapExpand: 'Tocar para expandir',
    tapClose: 'Tocar para cerrar',
    language: 'Idioma'
  },
  hero: {
    tag: 'Fabricante de iluminación escénica · Desde 2010',
    title: 'Ilumina cada escenario<br>con iluminación profesional',
    sub: 'Soluciones de iluminación escénica de alta calidad — moving head, par, strobe y LED. Exportamos a más de 50 países.',
    browseProducts: 'Ver productos',
    chatWa: 'Chatear en WhatsApp'
  },
  quicknav: {
    title: 'Navegación rápida',
    products: 'Productos',
    productsDesc: 'Explorar toda la iluminación',
    examples: 'Proyectos',
    examplesDesc: 'Casos reales',
    about: 'Nosotros',
    aboutDesc: 'Fábrica y empresa',
    contact: 'Ventas',
    contactDesc: 'WhatsApp para cotización rápida'
  },
  featured: {
    eyebrow: 'MÁS VENDIDOS',
    title: 'Productos destacados',
    desc: 'Nuestra iluminación escénica más popular — la confianza de clientes en más de 50 países.',
    viewAll: 'Ver todos los productos',
    badge: 'Top',
    empty: 'No hay productos destacados por ahora.'
  },
  sections: {
    whyEyebrow: 'POR QUÉ ELEGIRNOS',
    whyTitle: 'Nuestras ventajas',
    whyDesc: 'Con amplia experiencia, destacamos en innovación y producción a gran escala, ofreciendo soluciones de iluminación escénica de alta calidad que cumplen estándares mundiales.',
    svcEyebrow: 'LO QUE OFRECEMOS',
    svcTitle: 'Nuestros servicios',
    svcDesc: 'Una gama completa de soluciones de iluminación escénica — desde productos personalizados hasta envío global y soporte técnico remoto.',
    contactEyebrow: 'CONTÁCTENOS',
    contactTitle: 'Envíe una consulta',
    contactDesc: '¿Prefiere correo? Deje sus datos y le responderemos en 24 horas.'
  },
  cta: {
    title: '¿Necesita una cotización en minutos?',
    desc: 'Escríbanos por WhatsApp — nuestro equipo de ventas suele responder en 10 minutos durante el horario laboral.',
    emailUs: 'Correo'
  },
  product: {
    heroTitle: 'Productos',
    heroDesc: 'Iluminación escénica de alta calidad, con control flexible, estabilidad excepcional y seguridad confiable — diseñada para elevar cada presentación y evento.',
    searchPlaceholder: 'Buscar productos por palabra clave...',
    search: 'Buscar',
    sortBy: 'Ordenar por',
    sortDefault: 'Predeterminado',
    sortNewest: 'Más recientes',
    sortAsc: 'Precio: de menor a mayor',
    sortDesc: 'Precio: de mayor a menor',
    categories: 'Categorías',
    results: 'productos',
    in: 'en',
    filterToggle: 'Categorías',
    allTypes: 'Todos',
    noImg: 'Sin img'
  },
  productDetails: {
    loadingProduct: 'Cargando producto…',
    notFound: 'Producto no encontrado.',
    backToProducts: '← Volver a productos',
    keyAttributes: 'Atributos clave',
    moreSpecs: 'más especificaciones',
    blockDescription: 'Descripción del producto',
    noDescription: 'Sin descripción.',
    blockSpecs: 'Especificaciones',
    noSpecs: 'Sin especificaciones.',
    blockFaq: 'Preguntas frecuentes',
    inquiryTitle: 'Envíe una consulta',
    inquiryDesc: 'Cuéntenos qué necesita — solemos responder en 24 horas.',
    priceMeta: 'Pedido mín: 1 unidad · Descuentos por volumen'
  },
  example: {
    heroTitle: 'Proyectos',
    heroDesc: 'Instalaciones reales y producciones escénicas impulsadas por nuestras soluciones de iluminación en todo el mundo.',
    ctaWa: 'Obtener un montaje similar',
    empty: 'No hay proyectos en esta categoría aún.'
  },
  about: {
    heroTitle: 'Nosotros',
    heroSub: 'Guangzhou Huayang Stage Lighting — fabricante dedicado de iluminación escénica profesional desde 2010.',
    companyEyebrow: 'NUESTRA EMPRESA',
    purposeEyebrow: 'NUESTRO PROPÓSITO',
    purposeTitle: 'Iluminar escenarios, brillar en el futuro',
    teamEyebrow: 'CONTACTE AL EQUIPO',
    teamTitle: 'Servicio al cliente',
    teamDesc: 'Contacte directamente a nuestros especialistas de ventas — WhatsApp es la forma más rápida de obtener una cotización.',
    notSure: '¿No sabe a quién contactar?',
    routeMsg: 'Escriba a nuestra línea principal y le dirigiremos a la persona indicada.',
    leaveEyebrow: 'O DÉJENOS UN MENSAJE',
    leaveTitle: 'Deje sus datos',
    leaveDesc: 'También por correo — respondemos en 24 horas.',
    statYears: 'Años',
    statCountries: 'Países',
    statUnits: 'Unid/Año',
    statFactory: 'm² Fábrica',
    whyList1: 'Precios directos de fábrica',
    whyList2: 'Envío global',
    whyList3: 'Calidad garantizada'
  },
  footer: {
    productCenter: 'Centro de productos',
    viewAllProducts: 'Ver todos los productos',
    aboutTitle: 'Nosotros',
    aboutText: 'Guangzhou Huayang Stage Lighting, fundada en 2010, se especializa en equipos de iluminación escénica como moving heads y luces LED. Exportamos a más de 50 países, reconocidos por productos de alta calidad y excelente servicio.',
    contact: 'Contacto',
    chatWa: 'Chatear en WhatsApp',
    rights: 'Todos los derechos reservados.',
    waLabel: 'respuesta rápida',
    workingHours: 'Horario laboral'
  },
  leaveMessage: {
    fastest: 'Respuesta más rápida',
    title: 'Escríbanos por WhatsApp',
    replyMin: 'Nuestro equipo de ventas suele responder en <b>10 minutos</b> durante el horario laboral ({hours}).',
    orEmail: 'o envíe un correo',
    formTitle: 'Envíenos un correo',
    formSub: 'Complete el formulario — respondemos en 24 horas.',
    fullName: 'Nombre completo *',
    fullNamePh: 'Su nombre',
    phone: 'Teléfono *',
    phonePh: 'Incluya código de país',
    emailLbl: 'Correo electrónico *',
    emailPh: 'you@example.com',
    message: 'Mensaje *',
    messagePh: 'Cuéntenos qué productos le interesan, cantidades, destino, etc.',
    codePh: 'Ingrese el código',
    privacy: 'Su información es confidencial y solo se usa para responder su consulta.',
    errCode: 'Por favor ingrese el código de verificación.',
    errForm: 'Por favor complete información válida y completa.',
    okSent: '¡Mensaje enviado con éxito!',
    errCodeInvalid: 'Código de verificación inválido, inténtelo de nuevo.',
    errFail: 'Error al enviar. Inténtelo más tarde.'
  },
  trust: {
    assurance: 'Garantía comercial',
    assuranceDesc: 'Protección de pedido integrada',
    shipping: 'Envío global',
    shippingDesc: 'Mar / Aire / Exprés',
    quality: 'Calidad verificada',
    qualityDesc: 'Directo de fábrica'
  },
  stats: {
    years: '14+',
    yearsLbl: 'Años',
    countries: '50+',
    countriesLbl: 'Países',
    units: '100k+',
    unitsLbl: 'Unid/Año',
    factory: '7200',
    factoryLbl: 'm² Fábrica'
  }
};
